
import TagReminderService from '../../services/TagReminderService';
import TagService from '../../services/TagService';
import * as types from './types';
import { dispatchNetworkRequest } from '../networkDispatcher';

export const getTagReminders = (status, eventTemplateReminderId, page = 0, pageSize = 25, sort = '') => (dispatch) => {
  const promise = TagReminderService.getTagReminders(status, eventTemplateReminderId, page, pageSize, sort);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_TAG_REMINDERS_REQUESTED,
    successType: types.GET_TAG_REMINDERS_SUCCESS,
    errorType: types.GET_TAG_REMINDERS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading task reminders',
    responseName: 'tagReminders',
  });
  return promise;
};

export const getTagReminder = (id) => (dispatch) => {
  const promise = TagReminderService.getTagReminder(id);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_TAG_REMINDER_REQUESTED,
    successType: types.GET_TAG_REMINDER_SUCCESS,
    errorType: types.GET_TAG_REMINDER_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading task reminder',
    responseName: 'tagReminder',
  });
  return promise;
};

export const getTagRemindersForDueDate = (tagIds, maxDueDate) => (dispatch) => {
  const promise = TagReminderService.getTagRemindersForDueDate(tagIds, maxDueDate);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_TAG_REMINDERS_MAX_DUE_DATE_REQUESTED,
    successType: types.GET_TAG_REMINDERS_MAX_DUE_DATE_SUCCESS,
    errorType: types.GET_TAG_REMINDERS_MAX_DUE_DATE_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading task reminders',
    responseName: 'tagRemindersForDueDate',
  });
  return promise;
};

export const getTagRemindersForTag = (tagId) => (dispatch) => {
  const promise = TagService.getTagReminders(tagId);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.GET_TAG_TAG_REMINDERS_REQUESTED,
    successType: types.GET_TAG_TAG_REMINDERS_SUCCESS,
    errorType: types.GET_TAG_TAG_REMINDERS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading task reminders',
    responseName: 'tagReminders',
  });
  return promise;
};
